
	frappe.templates['sidebar'] = `<div class="body-sidebar-container {%= expanded ? 'expanded' : ''%}">
		<div class="body-sidebar">
			<!-- The standard-items band: search, notifications and background tasks, as
			     full-width rows directly under the header and above the module's own items.
			     The dock carries none of them -- see Sidebar.add_standard_items. It sits outside
			     .body-sidebar-top, the box that scrolls, so it stays put when a long sidebar
			     scrolls under it. -->
			<div class="standard-items-band"></div>
			<div class="body-sidebar-top">
				<div class="sidebar-items">
				</div>
			</div>
			<div class="body-sidebar-cards"></div>
			<div class="body-sidebar-bottom">
				<div class="promotional-banners"></div>
				<div class="nav-item dropdown-navbar-user dropdown-mobile mt-3">
					<a
						class="align-center btn-reset flex nav-link sidebar-user-button"
						style="width: 100%; min-height: 40px;"
						aria-label="{{ __("User Menu") }}"
					>
						<div> {{ avatar }} </div>
						<!-- The two lines take their size and their grey from the tokens that the
						     header title and subtitle take theirs from (see sidebar.scss), so the
						     Bootstrap classes .text-small, .text-secondary and .w-75 are off them:
						     each is a size or a grey from another system, and .text-secondary
						     carries an !important. Note: no apostrophes in this file. The template
						     compiler escapes only one per segment (see microtemplate.js), and a
						     second one is a syntax error in the compiled function, swallowed by a
						     catch that then hands back undefined. -->
						<div class="avatar-name-email overflow-hidden" style="margin-left: 8px;">
							<span class="d-block text-truncate">
								{{ frappe.session.user_fullname }}
							</span>
							<span class="d-block text-truncate">
								{{ frappe.session.user_email }}
							</span>
						</div>
					</a>
				</div>
			</div>
		</div>
		<!-- The panel edge, which collapses the panel to its rail and back from anywhere along
		     it, and the arrow that shows while the pointer is on it. Both sit half over the page,
		     so they are mounted beside the panel rather than in it: the panel clips anything that
		     overhangs it. The arrow is the one a keyboard reaches, so the edge is hidden from
		     assistive tech rather than being a second control with the same name. -->
		<div class="sidebar-edge" aria-hidden="true"></div>
		<button class="btn-reset sidebar-collapse-arrow" type="button">
			{%= frappe.utils.icon("chevron-left", "xs", "", "", "current-color", true) %}
		</button>
		<div class="overlay" style="z-index: 1021;"></div>
	</div>
</div>
`;
